/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, HostListener, inject, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { animate, style, transition, trigger } from '@angular/animations';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'banner-install-cicerone',
  standalone: true,
  imports: [ 
    CommonModule,
    TranslateModule,
    IonicModule
  ],
  templateUrl: './install-app.component.html',
  styleUrl: './install-app.component.scss',
  animations: [
    trigger('slideInOutFromBottom', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(100%)', height: 0 }),
        animate('200ms 7.5s', style({ opacity: 1, transform: 'translateY(0)', height: '50px' })),
      ]),
      transition(':leave', [
        animate('200ms', style({ opacity: 0, transform: 'translateY(100%)', height: 0 })),
      ]),
    ]),
    trigger('slideInOutFromTop', [
        transition(':enter', [
          style({ opacity: 1, transform: 'translateY(-100%)', height: 0 }),
          animate('200ms 7.5s', style({ opacity: 1, transform: 'translateY(0)', height: '50px' })),
        ]),
        transition(':leave', [
          animate('200ms', style({ opacity: 1, transform: 'translateY(-100%)', height: 0 })),
        ]),
    ]),
  ]
})

export class InstallAppComponent {
    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      if (!this.showBanner())
        return;

      this.currentWidth.update(prev => event.target.innerWidth)
      if (this.currentWidth() > this.getWitdthToTransition()) this.moveDefaultChatLegacy();
      else this.moveTopChatLegacy();
    }
    
    private observer: any;
    private canMoveLegacy = signal(false);
    private deferredPrompt: any;
    private enabledBanner = signal(false);
    private tools = inject(ToolsService);
    public isAppInstalled = computed(() => window.navigator['standalone'] == true || window.matchMedia('(display-mode: standalone)').matches);
    public isMobile = computed(() => window.innerWidth <= 500);
    public currentWidth = signal(window.innerWidth)
    public moveChatIfBannerShow = computed(() => this.currentWidth() > this.getWitdthToTransition());
    public showBanner = computed(() => {
        if (this.tools.enabledInstallBanner() && this.enabledBanner() && !this.isAppInstalled())
            return true

        this.moveDefaultChatLegacy();
        return false;
    });
    chatStyle: any;

    ngOnInit(){
        this.chatStyle = document.createElement('style');
        document.head.appendChild(this.chatStyle);
    }

    setObserver(){
        const element = document.querySelector('.toasty-wrapper'); 
        if (element){
            this.currentWidth.update(prev => window.innerWidth)
            this.moveTopChatLegacy();
        }

        this.observer = new MutationObserver((mutationsList) => {
            const element = document.querySelector('.toasty-wrapper'); 
            if (!element){
                if (this.currentWidth() > this.getWitdthToTransition()) this.moveDefaultChatLegacy();
                this.observer.disconnect(); 
            }
        });
        
        const targetNode = document.body;
        this.observer.observe(targetNode, { childList: true, subtree: true });
    }

    ngAfterViewInit(){
        window.addEventListener('beforeinstallprompt', (e) => {
            if (this.deferredPrompt)
                return;
            
            e.preventDefault();
            this.deferredPrompt = e;
            this.enabledBanner.update(prev => true);
            setTimeout(() => {
                this.canMoveLegacy.update(prev => true)
                this.setObserver();
            }, 7500);
        });
    }

    addAppToDesktop() {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then(() => {
            this.disableBanner();
        });
    }

    moveTopChatLegacy(){
        if (!this.chatStyle || this.moveChatIfBannerShow() || !this.canMoveLegacy() || !this.showBanner())
            return;

        this.chatStyle.innerHTML = '';
        const cssClass = `
            #button_container_chat{
                transition: all .2s linear; 
                bottom: 60px !important;
            }

            #toasty_container_chat{
                transition: all .2s linear; 
                bottom: 60px !important; 
            }
        `;
        this.chatStyle.appendChild(document.createTextNode(cssClass));
    }

    moveDefaultChatLegacy(){
        if (!this.chatStyle)
            return;
        
        this.chatStyle.innerHTML = '';
        const cssClass = `
            #button_container_chat{
                transition: all .2s linear; 
                bottom: 15px !important;
            }

            #toasty_container_chat{
                transition: all .2s linear; 
                bottom: 15px !important; 
            }
        `;
        this.chatStyle.appendChild(document.createTextNode(cssClass));
    }

    disableBanner(){
        this.enabledBanner.update(prev => false);
        this.observer?.disconnect(); 
    }

    getWitdthToTransition(){
        const toasty = document.querySelector('.toasty-wrapper');
        return toasty ? 1200 : 600
    }

}